import type { TranslationModule } from '../types';

export const iccjSectionTranslations: TranslationModule = {
  ro: {
    badge: "JURISPRUDENȚĂ ÎCCJ",
    title: "Jurisprudență ÎCCJ: RIL și Hotărâri Prealabile",
    subtitle: "Consultă deciziile Înaltei Curți de Casație și Justiție, inclusiv recursuri în interesul legii (RIL) și hotărâri prealabile pentru dezlegarea unor chestiuni de drept, organizate pe categorii și secțiuni.",
    checklist: [
      "Decizii RIL și hotărâri prealabile cu text integral disponibil",
      "Structură clară a hotărârilor (Istoric, Motivare, Dispozitiv)",
      "Acces la documentul PDF aferent fiecărei hotărâri disponibile",
      "Căutare rapidă în titlul sau în textul hotărârii",
      "Filtrare după secție, dată și categorii tematice"
    ],
    btnCTA: "Explorează Jurisprudența ÎCCJ",
    btnMore: "Toate Categoriile ÎCCJ",
    cards: {
      sync: {
        title: "Argumentare rapidă în dosare",
        desc: "<strong>1. Căutați deciziile</strong> relevante după cuvinte-cheie sau număr. <br /><strong>2. Identificați temeiul</strong> de drept și considerentele ÎCCJ. <br /><strong>3. Consultați dispozitivul</strong> sau documentul PDF disponibil."
      },
      portal: {
        title: "Secțiuni Structurate",
        desc: "Fiecare hotărâre poate fi parcursă pe secțiuni clare: datele dosarului, istoricul cauzei, considerentele instanței și textul dispozitivului."
      },
      search: {
        title: "Filtrare Tematică",
        desc: "Filtrați rapid deciziile după materia juridică, secția emitentă sau categorii tematice (Drept Civil, Drept Penal, Drept Administrativ etc.)."
      },
      party: {
        title: "Consultare și Descărcare PDF",
        desc: "Accesați documentul PDF al hotărârii direct din pagina dedicată fiecărei decizii pentru studiu sau documentare în dosar."
      },
      alerts: {
        title: "Corelare cu Legislația",
        desc: "Analizați articolele din coduri și legi invocate în cuprinsul deciziilor de recurs în interesul legii sau al hotărârilor prealabile ale Înaltei Curți."
      }
    },
    benefits_title: "AVANTAJE JURISPRUDENȚĂ ÎCCJ",
    benefits: [
      "Acces structurat la motivare și dispozitiv",
      "Căutare rapidă în textul integral al hotărârilor",
      "Vizualizare online optimizată pentru desktop și mobil"
    ],
    security: "Securizat & Privat"
  },
  en: {
    badge: "HIGH COURT CASE LAW",
    title: "High Court (ÎCCJ) Case Law: RIL & Preliminary Rulings",
    subtitle: "Search decisions of the High Court of Cassation and Justice of Romania, including appeals in the interest of the law (RIL) and preliminary rulings on questions of law.",
    checklist: [
      "Full-text access to RIL decisions and preliminary rulings",
      "Clear judgment structure (Facts, Reasoning, Operative Part)",
      "Access to the PDF document for each available decision",
      "Fast search across judgment titles and full text",
      "Filter by chamber, date, and thematic categories"
    ],
    btnCTA: "Explore ÎCCJ Case Law",
    btnMore: "All ÎCCJ Categories",
    cards: {
      sync: {
        title: "Fast Case Argumentation",
        desc: "<strong>1. Search rulings</strong> by keywords or number. <br /><strong>2. Identify legal basis</strong> and High Court reasoning. <br /><strong>3. Review the operative part</strong> or open the available PDF."
      },
      portal: {
        title: "Structured Rulings",
        desc: "Each judgment can be reviewed by clear sections: case details, procedural history, court reasoning, and operative part."
      },
      search: {
        title: "Thematic Filtering",
        desc: "Quickly filter rulings by legal area, issuing chamber, or thematic categories (Civil, Criminal, Administrative, etc.)."
      },
      party: {
        title: "View & Download PDF",
        desc: "Access the PDF document directly from each judgment's dedicated page for legal research and case preparation."
      },
      alerts: {
        title: "Correlated Legislation",
        desc: "Analyze code articles and laws referenced within appeals in the interest of the law or preliminary rulings of the High Court."
      }
    },
    benefits_title: "ÎCCJ CASE LAW ADVANTAGES",
    benefits: [
      "Structured access to reasoning and operative part",
      "Fast full-text search across judgments",
      "Mobile and desktop optimized reading view"
    ],
    security: "Secure & Private"
  },
  fr: {
    badge: "JURISPRUDENCE ÎCCJ",
    title: "Jurisprudence ÎCCJ : RIL et Décisions Préjudicielles",
    subtitle: "Consultez les décisions de la Haute Cour de Cassation et de Justice de Roumanie, y compris les recours dans l'intérêt de la loi (RIL) et les décisions préjudicielles.",
    checklist: [
      "Accès au texte intégral des décisions RIL et préjudicielles",
      "Structure claire des arrêts (Faits, Motivation, Dispositif)",
      "Accès au document PDF pour chaque décision disponible",
      "Recherche rapide dans le titre ou le texte intégral",
      "Filtrage par section, date et catégories thématiques"
    ],
    btnCTA: "Explorer la jurisprudence ÎCCJ",
    btnMore: "Toutes les catégories ÎCCJ",
    cards: {
      sync: {
        title: "Argumentation rapide des dossiers",
        desc: "<strong>1. Recherchez les arrêts</strong> par mots-clés ou numéro. <br /><strong>2. Identifiez la base légale</strong> et les motifs de la Haute Cour. <br /><strong>3. Consultez le dispositif</strong> ou le PDF disponible."
      },
      portal: {
        title: "Sections Structurées",
        desc: "Chaque décision peut être consultée par sections claires : historique de l'affaire, motifs de la Cour et dispositif."
      },
      search: {
        title: "Filtrage Thématique",
        desc: "Filtrez rapidement les décisions par matière juridique, chambre émettrice ou catégories thématiques (Civil, Pénal, Administratif, etc.)."
      },
      party: {
        title: "Consulter & Télécharger le PDF",
        desc: "Accédez au document PDF directement depuis la page dédiée à chaque décision pour vos recherches et dossiers."
      },
      alerts: {
        title: "Législation Corrélée",
        desc: "Analysez les articles de codes et de lois référencés dans les recours dans l'intérêt de la loi ou les décisions préjudicielles de la Haute Cour."
      }
    },
    benefits_title: "AVANTAGES JURISPRUDENCE ÎCCJ",
    benefits: [
      "Accès structuré aux motifs et au dispositif",
      "Recherche plein texte rapide dans les arrêts",
      "Interface optimisée pour ordinateur et mobile"
    ],
    security: "Sécurisé & Privé"
  }
};

export default iccjSectionTranslations;
